import { createGlobalStyle } from 'styled-components';

export const RechartStyles = createGlobalStyle`
    .recharts-cartesian-axis-tick-line {
        stroke: ${(props) => props.theme.palette.chart.axisTickLine};
    }
    .recharts-cartesian-axis-line {
        stroke: ${(props) => props.theme.palette.chart.axisLine};
    }
    .recharts-cartesian-axis-tick-value {
        fill: ${(props) => props.theme.palette.chart.axisTickValue};
    }
    .recharts-legend-item-text {
        color: ${(props) => props.theme.palette.text.secondary} !important;
    }
    .recharts-tooltip-cursor { // Background behind barchart pointed by tooltip
        fill: ${(props) => props.theme.palette.chart.tooltipObjectBackground};
    }
    .recharts-sector {
        stroke: transparent !important;
    }
    .recharts-default-tooltip {
        background-color: ${(props) =>
            props.theme.palette.chart.tooltipBackground} !important;
        border-color: ${(props) =>
            props.theme.palette.chart.tooltipBackground} !important;
    }
    .recharts-wrapper svg{
        overflow: inherit !important;
    }
`;
